import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import classNames from 'classname';

export const SuccessMessage = ({ title, iconSize }) => {
    return (
        <div className='success-message'>
            <CheckCircleIcon style={{ fontSize: iconSize }} />
            <span className='success-message__text'>{title}</span>
        </div>
    );
};

export const InfoMessage = ({ title, logger, iconSize, title2 }) => {
    const className = classNames({
        'info-message': true,
        'info-message--logger': logger,
    })
    return (
        <div className={className}>
            <InfoIcon style={{ fontSize: iconSize }} />
            <div>
                <span className='info-message__text'>{title}</span>
                <span className='info-message__text start-page-title2'>{title2}</span>
            </div>
        </div>
    );
};